import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

export interface AgenteLookupItem {
  value: string;
  label: string;
}

interface AgentiLookupResponse {
  agenti: AgenteLookupItem[] | null;
}

@Injectable({ providedIn: 'root' })
export class AgentiService {
  constructor(private http: HttpClient) {}

  getAgenti(): Observable<AgentiLookupResponse> {
    return this.http.get<AgentiLookupResponse>('api/lookup/agenti');
  }
}
